import React, { useContext, useEffect, useState } from "react";
import { NavContext } from "../../state/NavContext";
import { Form, Input, Button, Divider, Typography, Modal } from "antd";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { UserContext } from "../../state/UserContext";

const { Title, Text } = Typography;

const Login = () => {
  const history = useHistory();
  const { setUser } = useContext(UserContext);
  const [isLoading, setIsLoading] = useState(false);
  const { setActiveIndex, setIsSideBarActive } = useContext(NavContext);

  useEffect(() => {
    setActiveIndex("login");
    setIsSideBarActive(false);
  }, [setActiveIndex, setIsSideBarActive]);

  const onFinish = (values) => {
    setIsLoading(true);
    const { email, password } = values;

    axios
      .post("https://backendexample.sanbersy.com/api/user-login", {
        email,
        password,
      })
      .then((res) => {
        setIsLoading(false);

        const { token, user } = res.data;
        const { id, name, email } = user;

        const userData = {
          id,
          name,
          email,
          token,
        };
        setUser(userData);

        localStorage.setItem("user", JSON.stringify(userData));
        history.push("/admin/dashboard");
        console.log(userData);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err.response.data);

        Modal.error({
          title: "Failed",
          content: `Login failed, ${err.response.data.error}`,
        });
      });
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <div className="auth-form">
      <Title level={2} style={{ textAlign: "center", marginBottom: "40px" }}>
        Login
      </Title>
      <Form
        name="basic"
        layout="vertical"
        wrapperCol={{ span: 24 }}
        initialValues={{ remember: true }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Form.Item
          name="email"
          label="email"
          rules={[
            {
              type: "email",
              message: "The input is not valid E-mail!",
            },
            {
              required: true,
              message: "Please input your E-mail!",
            },
          ]}
        >
          <Input type="email" placeholder="Input your email" />
        </Form.Item>

        <Form.Item
          name="password"
          label="password"
          rules={[{ required: true, message: "Please input your password!" }]}
        >
          <Input.Password placeholder="Input your password" />
        </Form.Item>

        <Form.Item wrapperCol={{ span: 24 }}>
          <Button type="primary" htmlType="submit" block loading={isLoading}>
            Login
          </Button>
        </Form.Item>

        <Divider type="horizontal">
          <Text style={{ fontWeight: "normal" }} type="secondary">
            Don't Have An Account?
          </Text>
        </Divider>

        <Button
          onClick={() => history.push("/register")}
          className="btn-success"
          type="primary"
          block
        >
          Register
        </Button>
      </Form>
    </div>
  );
};

export default Login;
